import { Injectable, Pipe, PipeTransform } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import DOMPurify from 'dompurify';

@Injectable({
  providedIn: 'root',
})
@Pipe({
  name: 'changeLanguage',
  pure: false,
})
export class ChangeLanguagePipe implements PipeTransform {
  private fallbackLanguages = ['en', 'es'];
  private keywordsToHighlight = [
    'Recomendación:',
    'Hallazgo:',
    'Recommandation:',
    'Résultat:',
    'Recommendation:',
    'Finding:',
    'Find:',
    'Recomendação:',
    'Constatação:',
  ];

  constructor(private translateService: TranslateService) {}

  transform(value: any): string {
    if (!value || typeof value !== 'object') return '';
    const lang = this.translateService.currentLang || 'en';
    let text = value[lang]?.trim() || this.getFallback(value) || '';
    text = text.replace(/\\r\\n|\\n|\\r|\r\n|\n|\r/g, '<br>');
    this.keywordsToHighlight.forEach(keyword => {
      const regex = new RegExp(keyword, 'g');
      text = text.replace(regex, `<strong>${keyword}</strong>`);
    });
    return DOMPurify.sanitize(text, {
      ALLOWED_TAGS: ['br', 'strong'],
      ALLOWED_ATTR: [],
    });
  }
  private getFallback(field: any): string {
    for (const fallback of this.fallbackLanguages) {
      if (field[fallback]?.trim()) return field[fallback].trim();
    }
    return '';
  }
}
